import { render, staticRenderFns } from "./LatestWinnerTickets.vue?vue&type=template&id=63de2777&scoped=true&"
import script from "./LatestWinnerTickets.vue?vue&type=script&lang=js&"
export * from "./LatestWinnerTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63de2777",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
